import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { dispatch as storeDispatch } from '@store';
import { actions } from '@store/snackbars';

var SnackbarsServiceClass = /*#__PURE__*/function () {
  function SnackbarsServiceClass() {
    _classCallCheck(this, SnackbarsServiceClass);
  }

  _createClass(SnackbarsServiceClass, [{
    key: "open",
    value: function open(snackbarId, data) {
      var dispatch = storeDispatch;
      var snackbarAction = dispatch(actions.snackbarInit({
        snackbarId: snackbarId,
        data: data,
        isOpen: true
      }));
      snackbarAction["catch"](function (error) {
        return error;
      });
      return snackbarAction;
    }
  }, {
    key: "close",
    value: function close(snackbarId) {
      storeDispatch(actions.snackbarInitClosing({
        snackbarId: snackbarId
      }));
    }
  }, {
    key: "closeWithAnswer",
    value: function closeWithAnswer(snackbarId, _ref) {
      var _ref$accepted = _ref.accepted,
          accepted = _ref$accepted === void 0 ? false : _ref$accepted,
          _ref$rejected = _ref.rejected,
          rejected = _ref$rejected === void 0 ? false : _ref$rejected;
      storeDispatch(actions.snackbarInitClosingWithAnswer({
        snackbarId: snackbarId,
        accepted: accepted,
        rejected: rejected
      }));
    }
  }]);

  return SnackbarsServiceClass;
}();

var SnackbarsService = new SnackbarsServiceClass();
export { SnackbarsService };